import dynamic from 'next/dynamic';

import { MenuTrigger } from 'react-aria-components';
import { Menu, MenuItem } from 'components/ui/menu';
import { Button } from 'components/ui/button';
import { dataLayerHandleEvent } from 'utils/dataLayers';
import { ShareFacebookSVG, ShareTwitterSVG, SharePinterestSVG, ShareWhatsappSVG } from 'components/iconsSVG/social';
import { useI18n } from 'context/i18n';
import { isDomain } from 'utils/domain';

import styles from './style.module.css';

const ArrowRightSVG = dynamic(() => import('components/iconsSVG/arrowRight').then((mod) => mod.ArrowRightSVG));

export function ProductShare({ baseUrl, code, image }) {
  const { t } = useI18n();
  const handleClickShareDropdown = () => {
    dataLayerHandleEvent({
      event: 'item_info',
      event_category: 'product detail',
      event_detail_1: 'share',
      event_detail_2: '',
    });
  };

  const handleDataShare = (event) => {
    dataLayerHandleEvent({
      event: 'share',
      event_category: 'social',
      event_detail_1: event.toLowerCase(),
      event_detail_2: '',
    });
  };

  const menu = () => {
    const href = baseUrl || '#';
    return (
      <Menu className="!flex border-0 px-2 py-1" placement="top" onAction={(key) => handleMenuAction(key)}>
        <MenuItem key="share-facebook" className="bg-neutral hover:opacity-70">
          <a onClick={() => handleDataShare('Facebook')} href={`http://www.facebook.com/sharer.php?u=${href}`} target="_blank" rel="noreferrer">
            <ShareFacebookSVG />
          </a>
        </MenuItem>
        <MenuItem key="share-twitter" className="bg-neutral hover:opacity-70">
          <a onClick={() => handleDataShare('Twitter')} href={`http://twitter.com/intent/tweet?url=${href}`} target="_blank" rel="noreferrer">
            <ShareTwitterSVG />
          </a>
        </MenuItem>
        <MenuItem key="share-pinterest" className="bg-neutral hover:opacity-70">
          <a
            onClick={() => handleDataShare('Pinterest')}
            href={`http://pinterest.com/pin/create/button/?url=${href}&media=${image}`}
            target="_blank"
            rel="noreferrer"
          >
            <SharePinterestSVG />
          </a>
        </MenuItem>
        <MenuItem key="share-whatsapp" className="bg-neutral hover:opacity-70">
          <a onClick={() => handleDataShare('Whatsapp')} href={`https://api.whatsapp.com/send?text=${href}`} target="_blank" rel="noreferrer">
            <ShareWhatsappSVG />
          </a>
        </MenuItem>
      </Menu>
    );
  };

  return isDomain('camper') ?
      <MenuTrigger>
        <button onClick={handleClickShareDropdown} className={styles.shareTrigger}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
            <path
              stroke="#000"
              d="M4.5 6.5h15c.636 0 1.128.21 1.459.541.331.331.541.823.541 1.459V17.5c0 .636-.21 1.128-.541 1.459-.331.331-.823.541-1.459.541H4.5c-.636 0-1.128-.21-1.459-.541-.331-.331-.541-.823-.541-1.459V8.5c0-.636.21-1.128.541-1.459.331-.331.823-.541 1.459-.541ZM9.5 6v14M9.5 6l4 4.5M9.5 6l-4 4.5M6.625 3.008A248 248 0 0 0 8.848 5.5H5.5a1.5 1.5 0 1 1 1.125-2.492ZM12.375 3.008c-.647.733-1.544 1.746-2.223 2.492H13.5a1.5 1.5 0 1 0-1.125-2.492Z"
            />
          </svg>
          <span dangerouslySetInnerHTML={{ __html: t('ficha.producto', 'share') }} />
        </button>
        {menu()}
      </MenuTrigger>
    : <MenuTrigger>
        <Button onPress={handleClickShareDropdown} className={styles.shareTrigger}>
          <span dangerouslySetInnerHTML={{ __html: t('ficha.producto', 'share') }} /> <ArrowRightSVG />
        </Button>
        {menu()}
      </MenuTrigger>;
}
